import { useEffect, useRef, useState } from "react";

const MOBILE = "(max-width: 767px)";
const REDUCED = "(prefers-reduced-motion: reduce)";

export const HeroBackground = ({ className = "" }) => {
  const [mode, setMode] = useState(null); // "desktop" | "mobile" | null (no video)
  const [ready, setReady] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    const reduced = window.matchMedia(REDUCED);
    const mobile = window.matchMedia(MOBILE);
    const saveData = navigator.connection?.saveData === true;
    const update = () => setMode(reduced.matches || saveData ? null : mobile.matches ? "mobile" : "desktop");
    update();
    reduced.addEventListener("change", update);
    mobile.addEventListener("change", update);
    return () => {
      reduced.removeEventListener("change", update);
      mobile.removeEventListener("change", update);
    };
  }, []);

  useEffect(() => {
    setReady(false);
    const v = videoRef.current;
    if (!v || !mode) return;
    v.load();
    v.play().catch(() => {});
  }, [mode]);

  return (
    <>
      <picture>
        <source media={MOBILE} srcSet="/hero/hero-mobile.webp" type="image/webp" />
        <source
          media="(min-width: 768px)"
          srcSet="/hero/hero-1280.webp 1280w, /hero/hero-1920.webp 1920w"
          sizes="100vw"
          type="image/webp"
        />
        <img
          src="/hero/hero-1920.webp"
          alt="Traditionella röda svenska trähus med vita knutar vid sjö och skog"
          fetchPriority="high"
          decoding="async"
          data-testid="hero-image"
          className={className}
        />
      </picture>
      {mode && (
        <video
          key={mode}
          ref={videoRef}
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          disablePictureInPicture
          aria-hidden="true"
          tabIndex={-1}
          poster={mode === "mobile" ? "/hero/hero-mobile.webp" : "/hero/hero-1280.webp"}
          onCanPlay={() => setReady(true)}
          data-testid="hero-video"
          data-mode={mode}
          className={`absolute inset-0 ${className} transition-opacity duration-1000 ${ready ? "opacity-100" : "opacity-0"}`}
        >
          <source src={`/hero/hero-${mode}.webm`} type="video/webm" />
          <source src={`/hero/hero-${mode}.mp4`} type="video/mp4" />
        </video>
      )}
    </>
  );
};
